// extracted by mini-css-extract-plugin
export var active = "_b5-7";
export var container = "_b5-0";
export var evenWidth = "_b5-4";
export var large = "_b5-5";
export var outlet = "_b5-8";
export var slide = "_b5-2";
export var small = "_b5-6";
export var tab = "_b5-3";
export var tabs = "_b5-1";